import { useAccountInfo } from '@/hooks/query/account';
import { Icon } from '@/components/icons/svg-icons';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { headerStyle } from '@/components/layout/header/header.style';
import { isDesktop } from 'react-device-detect';
import clsx from 'clsx';
import { matchSome } from '@nf/utils-common/fpw/monadic';
import { useAccountBalance } from '@/hooks/query';
import { useEffect, useState } from 'react';

type ProfileSimpleInfoProps = {
	showBalance?: boolean;
	toggleBalance?: () => void;
}

type ViewCriteria = {
	view: ViewEnum;
	isDesktop: boolean;
}

export const ProfileSimpleInfo = ({ 
	toggleBalance,
	showBalance
}: ProfileSimpleInfoProps) => {
	const { user } = useAccountInfo();
	const { refetch } = useAccountBalance();
	const CurrencyName = user?.LicenseeSiteSetting?.DisplayCurrencyName;
	const view = useAppearanceStore(state => state.view);
	const [isLoading, setIsLoading] = useState(false);
	const [isShowBalance, setIsShowBalance] = useState(showBalance || view === ViewEnum.galaxy);

	useEffect(() => {
		setIsShowBalance(showBalance || view === ViewEnum.galaxy);
	}, [showBalance, view]);

	const onCurrencyDivClick = () => {
		// 除mars desktop模式外需點擊此區塊需切換是否顯示餘額外, 其餘皆是更新餘額
		matchSome({ view, isDesktop })
			.on(({ view, isDesktop }: ViewCriteria) => view === ViewEnum.mars && isDesktop, () => {
				if (toggleBalance) toggleBalance()
			})
			.otherwise(() => updateBalance());
	}

	const onBalanceDivClick = () => {
		// 因無論desktop, mobile; galaxy, mars點擊此區域皆為更新balance因此先不分流程
		updateBalance();
	}

	const updateBalance = () => {
		if (isShowBalance) {
			setIsLoading(true);
	
			refetch();
	
			setTimeout(() => {
				setIsLoading(false);
			}, 1000);
		}
	}

	return (
		<div className={clsx('header__account-info', { [headerStyle.accountInfo]: view === ViewEnum.mars })} data-active={isLoading ? true : undefined}>
			<div
				className={clsx('header__currency', headerStyle.currency)}
				onClick={onCurrencyDivClick}
			>
				{
					user?.CanSeeAvailableFunds && view === ViewEnum.mars ? (
						<div className={headerStyle.eyeIcon}>
							<Icon name={isShowBalance ? 'eye-open' : 'eye-close'} className={headerStyle.smIcon} />
						</div>
					) : null
				}
				{ (user?.CanSeeAvailableFunds && isShowBalance) ? (
					<div className={headerStyle.refreshMobile}>
						<Icon name="refresh" className={headerStyle.smIcon} />
					</div>
				) : null }
				{
					(user?.CanSeeAvailableFunds || user?.CanSeePendingFunds) &&
					CurrencyName
				}
			</div>
			<div 
				className={clsx('header__balance', headerStyle.balance)}
				onClick={onBalanceDivClick}
			>
				{user?.CanSeeAvailableFunds && (
					<>
						{isShowBalance && (
							<div className={headerStyle.refreshDesktop}>
								<Icon name="refresh" className={headerStyle.smIcon} />
							</div>
						)}
						{isShowBalance ? user?.BCredit : '********'}
					</>
				)}
			</div>
		</div>
	);
};